export default "__VITE_ASSET__48f7f36c__"